module.exports = __webpack_public_path__ + "img/hero_portrait_xl-min.72b84b93.png";